import styled from 'styled-components'

export const MyInvestmentWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
  gap: 20px;
  margin-top: 30px;
  // justify-items: center;

  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    // align-items: center;
    justify-items: center;
  }

  .spinner_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .no_investment_img {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
      padding-left: 20px;
    }
  }

  //myInvestmentCard

  .card_header {
    height: 160px;
    width: 310px;
    position: absolute;
    top: 0;

    .card_img {
      height: 160px;
      width: 310px;
      object-fit: cover;
      object-position: center;
      border-radius: 10px 10px 0 0;
    }
  }

  .card_body {
    padding: 20px 10px;
    height: 150px;
    margin-top: 5rem;
    width: 290px;

    .card_title {
      color: ${({ theme }) => theme.colors.black};
      font-style: normal;
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.x1};
      line-height: 29px;
      margin-bottom: 0;
    }
  }

  .roi {
    span {
      color: ${({ theme }) => theme.colors.successGreen};
    }
  }

  .amount_date_wrapper {
    display: flex;
    justify-content: space-between;
  }

  .amount_text,
  .maturity_text {
    font-weight: 700;
  }

  .amount_title,
  .maturity_title {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.activeBlue};
  }

  //myInvestmentCard
`
